import {Trans} from "react-i18next";

export const NotFound = () => {
  return (
    <>
      <Trans>Page not found</Trans>.
    </>
  );
};
